import { render } from "./AiLoginPage.vue?vue&type=template&id=72b412d3&scoped=true&ts=true"
import script from "./AiLoginPage.vue?vue&type=script&lang=ts"
export * from "./AiLoginPage.vue?vue&type=script&lang=ts"

import "./AiLoginPage.vue?vue&type=style&index=0&id=72b412d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b412d3"]])

export default __exports__